export enum EnvelopeStatus {
  Completed = 'completed',
  Declined = 'declined',
  Delivered = 'delivered',
  Draft = 'draft',
  Error = 'error',
  Sending = 'sending',
  Sent = 'sent',
  Voided = 'voided',
}
